/* eslint-disable */

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 *
 * An element representing spacing and separators within sections
 */
export interface WithinSection {
  /** if not provided, `SMALL` will be used and an error will be logged */
  variant?: WithinSectionVariant;
}

export enum WithinSectionVariant {
  CLIENT_COULD_NOT_PARSE_WITHIN_SECTION_VARIANT = "CLIENT_COULD_NOT_PARSE_WITHIN_SECTION_VARIANT",
  /** SMALL - A small height spacer. */
  SMALL = "SMALL",
  /** MEDIUM - A medium height spacer. */
  MEDIUM = "MEDIUM",
}
